var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { BaseQuery, UPDATE } from './BaseQuery.js';
import { findOneOid } from './dbQueries.js';
import { areIndexesEqual } from './utils.js';
export class FindOneQuery extends BaseQuery {
    constructor(_b) {
        var { index, hydrate } = _b, rest = __rest(_b, ["index", "hydrate"]);
        super(Object.assign({ initial: null }, rest));
        this.run = async () => {
            const oid = await findOneOid({
                collection: this.collection,
                index: this.index,
                context: this.context,
            });
            this.setValue(oid ? await this.hydrate(oid) : null);
        };
        this[_a] = (index) => {
            if (areIndexesEqual(this.index, index))
                return;
            this.index = index;
            this.execute();
        };
        this.index = index;
        this.hydrate = hydrate;
    }
}
_a = UPDATE;
//# sourceMappingURL=FindOneQuery.js.map